export class UserType {
    userTypeId: number;
    name: string;
}